<template>
  <div>
    <Loader
      v-if="isLoading"
      class="mr-2 mt-6"
      loaderType="card-avatar, article, actions"
    />
    <v-container fill-height fluid v-else class="ma-0 pa-0">
      <v-row>
        <v-col cols="12">
          <v-tabs v-model="tab" show-arrows>
            <v-tabs-slider></v-tabs-slider>
            <template v-if="isDeveloper() && !isAdmin()">
              <v-tab class="tab-option" key="allSolutions" href="#allSolutions">
                {{ $vuetify.lang.t("$vuetify.tab.solutions_users_tab") }}
                <v-icon v-if="icons">mdi-phone</v-icon>
              </v-tab>
              <v-tab class="tab-option" key="projects" href="#projects" v-show="isAdmin()" >
                {{ $vuetify.lang.t("$vuetify.tab.solutions_projects_tab") }}
                <v-icon v-if="icons">mdi-phone</v-icon>
              </v-tab>
              <v-tab class="tab-option" key="mysolutions" href="#mysolutions" v-show="isDeveloper()">
                {{ $vuetify.lang.t("$vuetify.tab.solutions_developers_tab") }}
                <v-icon v-if="icons">mdi-phone</v-icon>
              </v-tab>
            </template>
            <template v-else>
              <v-tab class="tab-option" key="projects" href="#projects">
                {{ $vuetify.lang.t("$vuetify.tab.solutions_projects_tab") }}
                <v-icon v-if="icons">mdi-phone</v-icon>
              </v-tab>
              <v-tab class="tab-option" key="allSolutions" href="#allSolutions">
                {{ $vuetify.lang.t("$vuetify.tab.solutions_users_tab") }}
                <v-icon v-if="icons">mdi-phone</v-icon>
              </v-tab>
              <v-tab class="tab-option" key="mysolutions" href="#mysolutions" v-show="isDeveloper()">
                {{ $vuetify.lang.t("$vuetify.tab.solutions_developers_tab") }}
                <v-icon v-if="icons">mdi-phone</v-icon>
              </v-tab>
            </template>
          </v-tabs>
        </v-col>
      </v-row>
      <v-row  v-if="this.tab !== 'projects'">
        <v-col cols="12" md="12" v-if="this.tab !== 'projects'">
          <v-text-field
            v-model="searchText"
            outlined
            :label="$vuetify.lang.t('$vuetify.solution.search_label_txt')"
            prepend-inner-icon="search"
            @keypress.enter="search"
          >
            <template v-slot:append>
              <v-btn
                large
                class="text-capitalize font-weight-bold mt-n3 mr-n2"
                color="primary"
                append-icon="search"
                @click="search"
              >
                <span class="d-none d-sm-flex">{{ $vuetify.lang.t("$vuetify.solution.search_btn_txt") }}</span>
                <v-icon class="d-flex d-sm-none">search</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row class="pt-3" v-else></v-row>
      <v-row class="mt-n9">
        <v-col cols="12" xs="12" md="12">
          <v-tabs
            v-model="tab"
            :centered="centered"
            :grow="grow"
            :vertical="vertical"
            :right="right"
            :prev-icon="
              prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined
            "
            :next-icon="
              nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined
            "
            :icons-and-text="icons"
          >
            <v-tab-item key="allSolutions" value="allSolutions">
              <v-row v-if="allSolution && allSolution.length !== 0">
                <v-col
                  cols="12"
                  xs="12"
                  sm="6"
                  md="6"
                  lg="4"
                  xl="4"
                  v-for="item in allSolution"
                  :key="item.id"
                >
                  <SolutionCard :itemData="item"/>
                </v-col>
              </v-row>
              <v-row v-else class="justify-center align-center mt-16">
                <h1>Sorry, No result found :(</h1>
              </v-row>
            </v-tab-item>
            <v-tab-item key="mysolutions" value="mysolutions" v-if="isDeveloper()">
              <DeveloperSolution :isDevSolLoading="isDevSolLoading" />
            </v-tab-item>
            <v-tab-item key="projects" value="projects">
              <ProjectLists :solution_type="$route.query.stype" />
            </v-tab-item>
          </v-tabs>
        </v-col>
      </v-row>
      <!-- <v-row v-else>
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          v-for="item in allSolution"
          :key="item.id"
        >
          <SolutionCard :itemData="item" />
        </v-col>
      </v-row> -->
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import {
  LOAD_ALL_SOLUTION,
  LOAD_ALL_SOLUTION_BY_DEV
} from "@/store/_actiontypes";
import Loader from "@/components/common/loader/Loader";
import SolutionCard from "@/components/Solutions/SolutionCard";
import DeveloperSolution from "@/components/Solutions/DeveloperSolution";
import ProjectLists from "@/components/Projects/ProjectLists"
import { authorize } from "@/helpers/helper";
import { Role } from "@/helpers/role";
import jwt_decode from "jwt-decode";
import getEnv from "@/config/env";
import {
  SEGMENTS
} from '@/global/_constants';
export default {
  props: {
    role: String,
  },
  components: {
    Loader,
    SolutionCard,
    DeveloperSolution,
    ProjectLists
  },
  computed: {
    ...mapState({
      allSolution: (state) => state.solution.allSolution,
      user: (state) => state.account.user,
    }),
    ...mapGetters("loader", ["loading"]),
    size() {
      const size = { xs: "x-small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
  },
  // mounted() {
  //   this.getAllSolutions("",this.type);
  // },
  data() {
    return {
      isLoading: false,
      isDevSolLoading: false,
      searchText: "",
      tab: null,
      icons: false,
      centered: false,
      grow: false,
      vertical: false,
      prevIcon: false,
      nextIcon: false,
      right: false,
      PROJECT_SEGMENTS: SEGMENTS,
      tabs: 2,
      type: "Personalizer",
      isFirstRenderAfterReload: true,
      Role,
      authorize,
    };
  },
  created() {
    this.type = this.$route.query.stype;

    if (this.$route.query.sview ) {
       this.tab = this.tab = this.$route.query.sview || (this.role === "dev" ? "mysolutions" : "allSolutions");
    }
    
  
  },
  watch: {
    "tab": {
      handler: function(newTab) {
        if (newTab === 'projects') {
          this.updateTabQuery(newTab);
        }
        else if (this.tab && this.tab !== 'projects') {
          this.tab === 'mysolutions' ? this.getDevSolutions('', this.type) : this.getAllSolutions('',this.type);
          this.updateTabQuery(newTab);
        }
      },
      deep: true
    },
    "$route.query.stype": {
      handler: function (newType) {
        if (!this.isFirstRenderAfterReload) {
          this.type = newType;
          if (this.tab && this.tab === 'mysolutions') {
            this.getDevSolutions('', newType);
          } else if ( this.tab && this.tab !== 'projects'){
            this.getAllSolutions('', this.type);
          }
        } else {
          this.isFirstRenderAfterReload = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions("solution", [ LOAD_ALL_SOLUTION, LOAD_ALL_SOLUTION_BY_DEV ]),
    isDeveloper() {
      let parsedJWT = jwt_decode(this.user.access_token);
      return parsedJWT["scope"]?.includes("developer");
    },
    isAdmin(){
      let parsedJWT = jwt_decode(this.user.access_token);
      return parsedJWT["scope"]?.includes("admin");
    },
    getAllSolutions(searchKey, type) {
      this.isLoading = true;
      this.LOAD_ALL_SOLUTION({ searchText: searchKey, type: type })
      .then(
        (response) => {
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
        }
      );
    },
    getDevSolutions(searchKey, type) {
      this.isDevSolLoading = true;
      this.LOAD_ALL_SOLUTION_BY_DEV({ searchText: searchKey, type: type })
      .then((response) => {
        this.isDevSolLoading = false;
      })
      .catch((error) => {
        this.isDevSolLoading = false;
      });
    },
    search() {
      if (this.tab) {
        this.tab === "allSolutions" ? this.getAllSolutions(this.searchText, this.type) : this.getDevSolutions(this.searchText, this.type);
      } else {
        this.getAllSolutions(this.searchText, this.type);
      }
    },
    updateTabQuery(newTab) {
      const currentQuery = { ...this.$route.query };
      if (currentQuery.tab === newTab) {
        // Avoid redundant navigation
        return;
      }
      if (newTab == 'projects') {      
        this.$router.push({
        path: '/projects',
        query: {
          stype: this.$route.query.stype ,
        },
      }).catch(err => {
        // Ignore NavigationDuplicated error
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
      } else {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...currentQuery,
            sview: newTab,
          },
        }).catch(err => {
          // Ignore NavigationDuplicated error
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        });
      }

    },
  },
};
</script>

<style scoped>
</style>
